export default __webpack_public_path__ + "static/media/group.caa8b964.svg";